import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface EditablePluginProps {
  readOnly: boolean;
}

export const EditablePlugin = ({ readOnly }: EditablePluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => editor.setEditable(!readOnly), [editor, readOnly]);

  return null;
};
